var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBhsEbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.866,
    height: 28.496,
    viewBox: "0 0 151.866 28.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1484.776 -430.396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1362.776 296.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,159.776V133.7h5.4v9.93a8.169,8.169,0,0,1,2.288-1.592,7.014,7.014,0,0,1,3.006-.6,5.7,5.7,0,0,1,2.614.611,5.848,5.848,0,0,1,2.07,1.785,8.97,8.97,0,0,1,1.366,2.88,13.965,13.965,0,0,1,.5,3.884,11.98,11.98,0,0,1-.566,3.762,9.572,9.572,0,0,1-1.585,3,7.411,7.411,0,0,1-2.436,1.988,6.925,6.925,0,0,1-3.147.715,6.037,6.037,0,0,1-1.437-.156,5.053,5.053,0,0,1-1.166-.444,4.853,4.853,0,0,1-.977-.689,10.629,10.629,0,0,1-.863-.87l-.189.9a1.156,1.156,0,0,1-.444.766,1.517,1.517,0,0,1-.844.207Zm8.815-14.284a4.732,4.732,0,0,0-1.07.111,3.821,3.821,0,0,0-.889.326,3.3,3.3,0,0,0-.759.533,7.324,7.324,0,0,0-.7.74v7.664a3.459,3.459,0,0,0,1.325.952,4.13,4.13,0,0,0,1.5.27,3.225,3.225,0,0,0,1.377-.3,2.784,2.784,0,0,0,1.088-.952,5.053,5.053,0,0,0,.722-1.7,10.673,10.673,0,0,0,.259-2.544,11.859,11.859,0,0,0-.207-2.4,4.866,4.866,0,0,0-.585-1.577,2.268,2.268,0,0,0-.9-.863A2.51,2.51,0,0,0,130.815,145.492Z",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.3,159.776V133.7h5.4v9.6a8.748,8.748,0,0,1,2.118-1.348,6.627,6.627,0,0,1,2.725-.515,6.368,6.368,0,0,1,2.621.515,5.382,5.382,0,0,1,1.925,1.425,6.246,6.246,0,0,1,1.185,2.177,8.933,8.933,0,0,1,.4,2.743v11.477h-5.4V148.295a3.142,3.142,0,0,0-.611-2.062,2.191,2.191,0,0,0-1.792-.74,3.747,3.747,0,0,0-1.674.385,6.48,6.48,0,0,0-1.5,1.029v12.873Z",
    transform: "translate(-516.444)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.158,346.639a1.4,1.4,0,0,1-.444.47,1.165,1.165,0,0,1-.6.141,1.954,1.954,0,0,1-.766-.167c-.255-.107-.533-.23-.829-.355a9.417,9.417,0,0,0-1-.355,4.6,4.6,0,0,0-1.27-.167,2.674,2.674,0,0,0-1.577.392,1.26,1.26,0,0,0-.548,1.089,1.083,1.083,0,0,0,.355.833,3.321,3.321,0,0,0,.952.585,12.271,12.271,0,0,0,1.34.478c.5.152,1.011.322,1.533.5a12.718,12.718,0,0,1,1.533.655,5.644,5.644,0,0,1,1.34.922,4.081,4.081,0,0,1,.948,1.333,4.465,4.465,0,0,1,.355,1.881,6.167,6.167,0,0,1-.489,2.473,5.262,5.262,0,0,1-1.455,1.951,6.862,6.862,0,0,1-2.388,1.27,10.825,10.825,0,0,1-3.266.452,10,10,0,0,1-1.847-.174,12.775,12.775,0,0,1-1.785-.47,9.547,9.547,0,0,1-1.592-.7,7.022,7.022,0,0,1-1.255-.881l1.255-1.988a1.775,1.775,0,0,1,.541-.548,1.5,1.5,0,0,1,.818-.2,1.718,1.718,0,0,1,.844.207c.252.141.522.289.811.455a6.4,6.4,0,0,0,1.018.452,4.41,4.41,0,0,0,1.474.207,3.687,3.687,0,0,0,1.063-.13,1.917,1.917,0,0,0,.7-.355,1.463,1.463,0,0,0,.385-.5,1.4,1.4,0,0,0,.122-.574,1.176,1.176,0,0,0-.367-.889,3.2,3.2,0,0,0-.959-.6,11.609,11.609,0,0,0-1.348-.47c-.507-.144-1.018-.311-1.544-.5a12.386,12.386,0,0,1-1.544-.67,5.218,5.218,0,0,1-1.348-.992,4.594,4.594,0,0,1-.959-1.474,5.417,5.417,0,0,1-.367-2.107,5.493,5.493,0,0,1,.444-2.188,5.118,5.118,0,0,1,1.333-1.822,6.557,6.557,0,0,1,2.229-1.244,9.646,9.646,0,0,1,3.136-.463,10.162,10.162,0,0,1,1.892.174,9.519,9.519,0,0,1,1.714.485,7.979,7.979,0,0,1,1.462.74,6.887,6.887,0,0,1,1.166.933Z",
    transform: "translate(-988.399 -200.973)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(185.106 147.355)",
    fill: "#1d252c",
    fontSize: 1,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(186.856 158.196)",
    fill: "#1d252c",
    fontSize: 20,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E-BOOK")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(266.866 156.553)",
    fill: "#1d252c",
    fontSize: 21,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "]")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(179.678 156.553)",
    fill: "#1d252c",
    fontSize: 21,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "["))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhsEbook);
export default __webpack_public_path__ + "static/media/bhs_ebook.98bdcc799bc7b741ca9e82e2a56e2887.svg";
export { ForwardRef as ReactComponent };